import { render, staticRenderFns } from "./Cod.vue?vue&type=template&id=52d3de9f&scoped=true"
import script from "./Cod.vue?vue&type=script&lang=js"
export * from "./Cod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d3de9f",
  null
  
)

export default component.exports